import { Ban, Check, X } from "lucide-react";

const LETTERS = ["A", "B", "C", "D"];

export const OptionList = ({ options, selected, struck = [], correctIndex, onSelect, onStrike, disabled, showStrike = true }) => {
  const revealed = correctIndex != null;
  return (
    <div className="space-y-2 mt-3" data-testid="option-list">
      {options.map((opt, i) => {
        const isStruck = struck.includes(i);
        const isSel = selected === i;
        const isCorrect = revealed && i === correctIndex;
        const isWrongPick = revealed && isSel && i !== correctIndex;
        let cls = "border-slate-200 bg-white hover:border-slate-300";
        if (isSel && !revealed) cls = "border-blue-600 bg-blue-50";
        if (isCorrect) cls = "border-emerald-500 bg-emerald-50";
        if (isWrongPick) cls = "border-rose-400 bg-rose-50";
        return (
          <div key={i} className={`flex items-stretch gap-2 rounded-lg border-2 transition-colors ${cls}`}>
            <button
              type="button"
              data-testid={`option-${LETTERS[i].toLowerCase()}`}
              disabled={disabled || isStruck}
              onClick={() => onSelect(i)}
              className={`flex-1 flex items-start gap-3 p-2.5 sm:p-3 text-left rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 ${
                isStruck ? "opacity-40 cursor-not-allowed" : "cursor-pointer"
              } ${disabled && !isStruck ? "cursor-default" : ""}`}
            >
              <span
                className={`shrink-0 w-7 h-7 rounded-full border flex items-center justify-center text-sm font-semibold ${
                  isSel && !revealed
                    ? "bg-blue-700 border-blue-700 text-white"
                    : isCorrect
                    ? "bg-emerald-600 border-emerald-600 text-white"
                    : isWrongPick
                    ? "bg-rose-500 border-rose-500 text-white"
                    : "border-slate-300 text-slate-600"
                }`}
              >
                {isCorrect ? <Check className="w-4 h-4" /> : isWrongPick ? <X className="w-4 h-4" /> : LETTERS[i]}
              </span>
              <span className={`text-sm sm:text-base text-slate-800 leading-relaxed ${isStruck ? "line-through" : ""}`}>
                {opt}
              </span>
            </button>
            {showStrike && !revealed && (
              <button
                type="button"
                data-testid={`strikeout-toggle-${LETTERS[i].toLowerCase()}`}
                onClick={() => onStrike(i)}
                disabled={disabled}
                title={isStruck ? "Remove strikeout" : "Strike out this choice to visually eliminate it (it stays selectable if you change your mind)"}
                className={`self-center mr-2 p-2 rounded-md transition-colors ${
                  isStruck ? "text-rose-500 bg-rose-50" : "text-slate-300 hover:text-slate-500 hover:bg-slate-100"
                }`}
              >
                <Ban className="w-4 h-4" strokeWidth={2} />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};
